import React from 'react';
import { Yes, No, BackArrow, UpArrow, LoseWeight, Energy, Immunity, Focus, Face, Eye, Smile, Gut, AntiAging, HeartHealth, Fruit, Shoe, Blackcurrant, Orange, Strawberry, Cola, Pineapple, Original, Peach, Apple, QuestionMark, Information, PeriodHealth, ExcessHair, ImproveHair, HotFlash, SexualHealth, Sleep, Bone, Watermelon } from '../../core-quiz/icons/Icons';

const Check = <svg xmlns="http://www.w3.org/2000/svg" className="svgCheck" viewBox="0 0 515.556 515.556" width="20" height="20"><path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" /></svg>;

export const GetPriorityIcon = (priority) => {
  switch (priority) {
    case 'Lose weight or tone up':
      return <LoseWeight />
    case 'More energy':
      return <Energy />
    case 'Better immunity':
      return <Immunity />
    case 'Better focus & memory':
      return <Focus />
    case 'Improve skin':
      return <Face />
    case 'Better stress management & mental wellbeing':
      return <Smile />
    case 'Delay signs of aging':
      return <AntiAging />
    case 'Cardiovascular health':
      return <HeartHealth />
    case 'Improve performance, endurance & recovery':
      return <Shoe />
    case 'Healthier hair & nails':
      return <ImproveHair />
    case 'Tackle excess hair':
      return <ExcessHair />
    case 'Menstrual cycle health':
      return <PeriodHealth />
    case 'Reduce hot flashes & sweating':
      return <HotFlash />
    case 'Gut health & digestion':
      return <Gut />
    case 'Increase libido / sexual health':
      return <SexualHealth />
    case 'Improve sleep quality':
      return <Sleep />
    case 'Bone & joint health':
      return <Bone />
    default:
      return Check
  }
}